import * as React from 'react';
import classNames from 'classnames';

import './KiteLoader.scss';

export interface ILoaderProps {
  /** Additional classNames */
  className?: string;
  /** If true, the color will be #fff, otherwise the default color of the spinner is #0073d1. */
  useLight?: boolean;
  /** Size prop will be applied to the loader circle. Should be set to 'small', 'medium', or 'large' to follow Kite design spec. Valid CSS size is still supported as well. */
  size?: string;
}

const KiteLoader = ({ className, useLight, size }: ILoaderProps) => {
  const getStrokeColor = () => {
    if (useLight) {
      return '#fff';
    }
    return '#0073d1';
  };

  const sizePixels = {
    small: '24px',
    medium: '40px',
    large: '80px',
  };

  const loaderSize = size && sizePixels[size] ? sizePixels[size] : size;

  let loaderStyles = {};
  loaderStyles = size
    ? { ...loaderStyles, height: loaderSize, width: loaderSize }
    : loaderStyles;
  const displayLoader = () => {
    return (
      <>
        <svg
          className="kite-loader__svg"
          viewBox="25 25 50 50"
          focusable="false"
          role="img"
          aria-label="loading"
          style={{ animation: 'rotate 1.5s linear infinite' }}
        >
          <circle
            className="kite-loader__circle--indeterminate"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            strokeWidth="2px"
            strokeMiterlimit="10"
            strokeLinecap="butt"
            style={{
              stroke: getStrokeColor(),
              transition: 'stroke 1s ease-in-out',
            }}
          />
        </svg>
      </>
    );
  };

  return (
    <>
      <span
        className={classNames({
          'kite-loader': true,
          'kite-loader--light': useLight,
          [className || '']: className,
        })}
      >
        <span className="kite-loader__loader" style={loaderStyles}>
          {displayLoader()}
        </span>

        <p className="kite-loader__reduced-motion">Loading</p>
      </span>
    </>
  );
};

export default KiteLoader;
